import { Paper, } from '@mui/material';
import React, { useCallback, useState } from 'react';
import { StudyRequestForm } from '../../components/StudyRequestForm';
import { StudyRequestInterface } from '../../interfaces';
import { useResponseHandlerService, useStudyRequestService, useTranslation } from '../../services';
import styles from './StudyRequest.module.css';
import { useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { DescriptionForm } from '../../components/DescriptionForm';
import StudyRequestHeader from './StudyRequestHeader';
import StudyRequestConfirm from './StudyRequestConfirm';

const StudyRequest = ({basicFlow=false}) => {
	const { user, isAuthenticated } = useAuth0();
	const studyRequestService = useStudyRequestService();
	const { addSuccess } = useResponseHandlerService();
	const location = useLocation();
	const isAdminRequest = location.pathname === "/admin/study-request";
	const { t } = useTranslation();
	const [requestId, setRequestId] = useState<string | null>(null);
	const defaultFormValues = {
		name: isAdminRequest && isAuthenticated ? user?.name : '',
		email: isAdminRequest && isAuthenticated ? user?.email : '',
		students: [],
		unit: '',
		phone: isAdminRequest && isAuthenticated ? user?.phone_number || '+380500000000' : '',
		description: '',
		requestAttachments: [],
		isMilitary: undefined,
	};
	const [defaultValues, setDefaultValues] = useState<StudyRequestInterface>(defaultFormValues);

	const onSubmit = useCallback(
		async (data: StudyRequestInterface) => {
			data.students = data.students?.map((student) => ({
				name: student.name,
				email: student.email,
			}));
			try {
				let res;
				if (isAdminRequest) {
					res = await studyRequestService.createAdminStudyRequest(data)
				} else if (basicFlow) {
					res = await studyRequestService.createStudyRequestBasic(data)
				} else {
					res = await studyRequestService.createStudyRequest(data);
				}
				res.id && setRequestId(res.id);
				addSuccess(t('Study Request was successfully sent.'));
			} catch (error: any) {
				console.error(error);
			}
		},
		[studyRequestService, addSuccess, t, basicFlow]
	);


	const reset = () => {
		setRequestId(null);
		setDefaultValues(defaultFormValues);
	};

	return (
		<div className={styles.main}>
			<StudyRequestHeader />
			{!requestId ? (
				<>
					{ !isAdminRequest && (<DescriptionForm />)}
					<Paper elevation={2} className={styles.background}>
						<StudyRequestForm onSubmit={onSubmit} values={defaultValues} basicFlow={basicFlow}/>
					</Paper>
				</>
			) : (
				<StudyRequestConfirm requestId={requestId} onReset={reset} />
			)}
		</div>
	);
};

export default StudyRequest;
